import React, { useMemo, useState } from "react";

//Components
import Autocomplete from "../Autocomplete";

//Channels
import {  channels as channelsEntity, channelsSelect } from "../../../models/Channels";

const AutocompleteChannels = ({ value, isFranchise, ...rest }) => {
    const [channels, setChannels] = useState(channelsSelect);

    const option = useMemo(() => {
        if (isFranchise) {
            const channelsFiltered = channelsSelect.find(o => o.value === channelsEntity.values.Franchises);
            setChannels(channelsFiltered ? [channelsFiltered] : channelsSelect);
            value = channelsEntity.values.Franchises;
        }

        if (!value) return '';

        return channelsSelect.find(o => o.value === value);
    }, [value, isFranchise])

    return (
        <Autocomplete
            fullWidth
            label='Canal'
            name='channel'
            {...rest}
            value={option}
            options={channels}
            isOptionEqualToValue={(option, value) => option.value === value}
            data-testid='channel-autocomplete'
        />
    );
}

export default AutocompleteChannels;